export const UNDOREDO = "undoRedo" as const;
export const BOLD = "bold" as const;
export const ITALIC = "italic" as const;
export const STRONG = "strong" as const;
export const EMPHASIZED = "emphasized" as const;
export const BULLET_LIST = "bulletList" as const;
export const ORDERED_LIST = "orderedList" as const;
export const APOSTROPHE = "apostrophe" as const;
export const DIV = "div" as const;
export const VARIABLE = "variable" as const;
export const DIRECTIVE = "directive" as const;

export type ToolbarButtonId =
  | typeof UNDOREDO
  | typeof BOLD
  | typeof ITALIC
  | typeof STRONG
  | typeof EMPHASIZED
  | typeof BULLET_LIST
  | typeof ORDERED_LIST
  | typeof APOSTROPHE
  | typeof DIV
  | typeof VARIABLE
  | typeof DIRECTIVE;

export const DEFAULT_TOOLBAR_BUTTONS: ToolbarButtonId[] = [
  UNDOREDO,
  BOLD,
  ITALIC,
  STRONG,
  EMPHASIZED,
  BULLET_LIST,
  ORDERED_LIST,
  APOSTROPHE,
  DIV,
  VARIABLE,
  DIRECTIVE,
];
